import { render, staticRenderFns } from "./KYCList.vue?vue&type=template&id=2042425f&scoped=true"
import script from "./KYCList.vue?vue&type=script&lang=js"
export * from "./KYCList.vue?vue&type=script&lang=js"
import style0 from "./KYCList.vue?vue&type=style&index=0&id=2042425f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2042425f",
  null
  
)

export default component.exports